import Animation from '../../animations/animation'
import LineTransformer from '../transformers/line-bar-transformer'
import * as d3 from 'd3-selection'
import PieTransformer from '../../../pie/transformers/pie-bar-transformer'
import * as ease from 'd3-ease'
import { EPSILON } from 'chart-constants'

/*
 * This animation is used to take a single serie that was previously
 * a pie and turn it into a line.
 */
class FromPieAnimation extends Animation {

  constructor (options) {
    super(options)
    this.twoPart = true
    this.ripple = true
  }

  match (serie) {
    let prev = this.previous.allSerieTypes[serie.id]
    return prev && (prev.type === 'pie'  ||
           prev.type === 'donut')
  }

  animate (serie, entering, selection, merged, exiting) {
    // Add the final line into the DOM
    this._initialInsert(entering)

    // Then hide it
    entering.selectAll('path')
            .style('display', 'none') // We don't want to show the path yet

    entering.selectAll('.point')
            .style('opacity', EPSILON) // We'll fade in the points
            .style('display', '')

    let pies = this.previous.allSerieTypes[serie.id].serie
      , self = this

    let styles = {
        stroke: entering.selectAll('path.line.data-line').style('stroke'),
        strokeWidth: entering.selectAll('path.line.data-line').style('stroke-width'),
        fill: pies.selectAll('use').style('fill')
      }
      , lineTransformer = new LineTransformer({
          serie: entering,
          previous: self.previous,
          scalers: self.scalers,
          yScale: self.yScale,
          lineScale: self.scalers,
          splitScale: d => {
            return self.scalers.x.groupScale(d.rangeId) + self.serieScale(serie._columnIdx)
          },
          splitWidth: self.serieScale.bandwidth(), // The width of the split lines
          styles: {
            line: styles,
            bar: styles
          }
        })
      , splits = lineTransformer.insert(1) // Insert splits as bars
                                .style('display', 'none') // Don't show the split bars yet

    // Pies to bars
    pies.transition()
        .duration(this.timing.duration)
        .delay(this.timing.delay)
        .ease(ease.easeCubicIn)
        .selectAll('use')
        .tween('pies', function (d) {
          // Convert from pie slices to bars
          let transformer = new PieTransformer({
            d,
            styles: d.styles,
            width: self.serieScale.bandwidth(),
            x: self.scalers.x.groupScale(d.rangeId) + self.serieScale(serie._columnIdx),
            height: Math.abs(self.yScale(d.slice.data._range[0]) - self.yScale(d.slice.data._range[1])),
            y: self.yScale(Math.max(0, d.slice.data._range[1])),
            path: d3.select(`#${d.pathUid.id}`),
            use: d3.select(this)
          })

          return t => {
            transformer.transform(1 - t) // reverse the timing
          }
        })
        .transition()
        .ease(ease.easeCubicOut)
        .tween('line', function (d) {
          // convert from bars to lines

          // Grab the split that represents a bar for this pie slice
          let split = splits.filter(split => {
            return split._data.rangeId == d.rangeId
          })

          d3.select(this).remove() // Remove the pie slice that turned into a bar

          split.style('display', '') // Show this split

          return t => {
            lineTransformer.transform(1 - t, split.node())
          }
        })
        .end().then(() => {
          // Show the real area
          entering.selectAll('path')
                  .style('display', '') // Show actual line chart

          splits.remove() // Remove transition pieces
        })


    // Remove previous lines

    // previousSerie.selectAll('path').remove()
  }

}

export default FromPieAnimation
